/**
 * AB#1797 (CR-2026-05-29) — TanStack Query hook for the Appointments List V2.
 *
 * Disabled (returns empty) when the feature flag is OFF so the page degrades
 * gracefully without crashing. The flag mirrors `Appointments:ListV2:Enabled`
 * on the BE — both default to OFF until Sprint 6 retro.
 */

import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import { getSalonOwnerAppointments, AppointmentsListParams } from '../services/appointmentsList';
import { useAuthContext } from '../contexts/AuthContext';

// AB#1797 UAT FORCE-ON (CR-2026-05-30): was
// `const FLAG_ENABLED = process.env.REACT_APP_APPOINTMENTS_LIST_V2_ENABLED === 'true';`
// Hardcoded to `true` so the founder's UAT pass actually fires the query
// instead of disabling it. Revert with the rest of the force-on chain
// (App.tsx + AppointmentCard.tsx + AppointmentsListPage planTier override).
const FLAG_ENABLED = true;

export function useSalonOwnerAppointments(params: AppointmentsListParams) {
    const { accessToken } = useAuthContext();

    return useQuery({
        queryKey: queryKeys.appointments.listV2(params as Record<string, unknown>),
        queryFn: () => getSalonOwnerAppointments(params, accessToken ?? ''),
        enabled: FLAG_ENABLED && !!accessToken,
        staleTime: 30_000,
    });
}
